import React, { useState, useEffect } from 'react';

const VIBE_MESSAGES = [
  "vibing out",
  "just vibin'",
  "catching vibes",
  "vibes incoming",
  "feeling the vibes",
  "riding the vibe wave",
  "in the vibe zone",
  "vibing hard",
  "locked in the vibe",
  "channeling good vibes",
  "cooking up some vibes",
  "vibing with your code",
  "straight vibing",
  "flowing with the vibes",
  "tuned into the vibes",
  "vibe mode activated",
  "sending good vibes",
  "vibing intensely",
  "deep in the vibes"
];

export const VibeText: React.FC = () => {
  const [message, setMessage] = useState(() =>
    VIBE_MESSAGES[Math.floor(Math.random() * VIBE_MESSAGES.length)]
  );

  // Message stays the same for the entire component lifetime
  // It only changes when the component unmounts and remounts (new agent round)

  return (
    <span className="vibe-text">
      {message}
    </span>
  );
};
